const $$splitNotFoundComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/index.tsx?tsr-split=notFoundComponent');
const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from 'src/lib/translations/i18n';
import { saveLastVisitedVisualization } from 'src/lib/utils/loop-visualizations/lastVisitedVisualizationView';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/')({
  loader: ({
    params
  }) => saveLastVisitedVisualization(Number(params.viewId), 'swimlane'),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  notFoundComponent: lazyRouteComponent($$splitNotFoundComponentImporter, 'notFoundComponent'),
  staticData: {
    topNav: {
      title: i18n.t('roadmaps.title')
    }
  }
});